import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DropdownItem } from '@widgets/dropdown/dropdown-type';
import {
  Alert,
  AlertConfiguration,
  AlertFilter,
  AlertGroup,
  AlertRecipientGroup,
  AlertType,
  BusinessPartner,
  MutedAlertFilter,
  MutedStation,
  MuteStationRequest,
  Paging,
  PartnerLocation,
  SelectedAlert,
  UpdateAlertConfiguration,
} from '../data/alerting.models';

export const AlertingActions = createActionGroup({
  source: 'Alerting',
  events: {
    'Get Partners': emptyProps(),
    'Set Partners': props<{ partners: BusinessPartner[] }>(),
    'Select Partner': props<{ partner: DropdownItem<BusinessPartner> }>(),
    'Select Partner By Id': props<{ partnerId: string }>(),
    'Select Location': props<{ location: DropdownItem<PartnerLocation> }>(),
    'Get Alerts': props<{ filter: AlertFilter }>(),
    'Set Alerts': props<{ alerts: Alert[] }>(),
    'Get Alerts Next Page': props<{ filter: AlertFilter }>(),
    'Set Alerts Paging': props<{ paging: Paging }>(),
    'Select Ev Driver Alert': props<{ alertId: number; partnerId: string }>(),
    'Select Session Alert': props<{ alertId: number; partnerId: string }>(),
    'Select Alert': props<{ alertId: number; partnerId: string }>(),
    'Set Alert Details': props<{ alert: SelectedAlert | null }>(),
    'Set No Stations Found': emptyProps(),
    'Mark As Resolved': props<{ alertId: number; partnerId: string }>(),
    'Get Groups': props<{ selectedGroupId?: number }>(),
    'Set Groups': props<{ groups: AlertGroup[] }>(),
    'Select Group': props<{ groupId: number }>(),
    'Unselect Group': emptyProps(),
    'Get Configurations': emptyProps(),
    'Set Configurations': props<{ configurations: AlertConfiguration[] }>(),
    'Save Configurations': props<{
      configuration: UpdateAlertConfiguration;
      alertType: AlertType;
    }>(),
    'Get Recipient Groups': props<{ selectedRecipientGroupId?: number }>(),
    'Set Recipient Groups': props<{ recipientGroups: AlertRecipientGroup[] }>(),
    'Select Recipient Group': props<{ recipientGroupId: number }>(),
    'Unselect Recipient Group': emptyProps(),
    'Toggle Alert Type': props<{ alertType: AlertType; value: boolean }>(),
    'Export Alerts': props<{ filter: AlertFilter }>(),
    'Export Alerts Finished': emptyProps(),
    'Get Muted Stations': props<{ filter: MutedAlertFilter }>(),
    'Set Muted Stations': props<{ stations: MutedStation[] }>(),
    'Get Muted Stations Next Page': props<{ filter: MutedAlertFilter }>(),
    'Set Muted Stations Paging': props<{ paging: Paging }>(),
    'Unmute Station': props<{ stationId: string; partnerId: string }>(),
    'Mute Station': props<{
      stationId: string;
      partnerId: string;
      muteRequest: MuteStationRequest;
    }>(),
    'Destroy Component': emptyProps(),
  },
});
